var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"xPadding titleModal"},[_vm._v(" "+_vm._s(_vm.$t("technicalFile.network.steam.step3.title"))+" ")]),_c('VTableHistory',{attrs:{"items":_vm.getHistory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }